import { render, staticRenderFns } from "./YoneticiListesi.vue?vue&type=template&id=37d568a2&scoped=true&"
import script from "./YoneticiListesi.vue?vue&type=script&lang=js&"
export * from "./YoneticiListesi.vue?vue&type=script&lang=js&"
import style0 from "./YoneticiListesi.vue?vue&type=style&index=0&id=37d568a2&lang=scss&scoped=true&"
import style1 from "./YoneticiListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d568a2",
  null
  
)

export default component.exports